module.exports = __webpack_public_path__ + "img/min.04e4e064.png";